export default "__VITE_ASSET__55495a0a__"